import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatButtonToggleChange} from "@angular/material/button-toggle";
import { StartupContactModel } from 'app/models/contact-form/startup-contact.model';

@Component({
  selector: 'app-ssdf-call-general-dashboard',
  templateUrl: './ssdf-call-general-dashboard.component.html',
  styleUrls: ['./ssdf-call-general-dashboard.component.scss']
})
export class SsdfCallGeneralDashboardComponent implements OnInit {
  @Input() selectedDashboardView: string;
  @Input() selectedDateFilter: string;
  @Input() filterDates: any;
  @Input()  showDashboardViewMenu : boolean;
  @Input() generalData: any;
  @Input() appForDay: any;
  @Input() batchData: any;
  @Input() formedCompanyData: any;
  @Input() zoneData: any;
  @Input() labNeededData: any;
  @Input() patentsData: any;
  @Input() fundingNeedPieData: any;
  @Input() originationData: any;
  @Input() appForTrl: any;
  @Input() fundingNeedBarData: any;
  @Input() appForPremoney: any;
  @Input() appForRegion: any;
  @Input() countryData: any;

  @Input() applicationList : StartupContactModel[];


  @Output() onChangeDateFilterState = new EventEmitter<any>();
  @Output() onChangeDashboardView = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }
  changeDateFilterState($event: MatButtonToggleChange) {
    this.onChangeDateFilterState.emit($event);
  }

  changeDashboardView(view: string) {
    this.onChangeDashboardView.emit(view);
  }
}
